/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUserProfile = /* GraphQL */ `
  mutation CreateUserProfile(
    $input: CreateUserProfileInput!
    $condition: ModelUserProfileConditionInput
  ) {
    createUserProfile(input: $input, condition: $condition) {
      id
      name
      pillars {
        title
        glowPercent
        __typename
      }
      projects {
        title
        backgroundColor
        shortName
        __typename
      }
      morningRoutineSteps
      eveningRoutineSteps
      tasks {
        description
        goalTag
        urgency
        category
        glowTask
        timeConstraintType
        timeConstraintTime
        associatedMilestone
        status
      }
      dates {
        date
        meals
        pxp
        gxp
      }
      goals {
        goalType
        title
        milestones
        timeConstraintType
        timeConstraintTime
        projectId
        isGlowGoal
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateUserProfile = /* GraphQL */ `
  mutation UpdateUserProfile(
    $input: UpdateUserProfileInput!
    $condition: ModelUserProfileConditionInput
  ) {
    updateUserProfile(input: $input, condition: $condition) {
      id
      name
      pillars {
        title
        glowPercent
      }
      projects {
        title
        backgroundColor
        shortName
      }
      morningRoutineSteps
      eveningRoutineSteps
      tasks {
        description
        goalTag
        urgency
        category
        glowTask
        timeConstraintType
        timeConstraintTime
        associatedMilestone
        status
      }
      dates {
        date
        meals
        pxp
        gxp
      }
      goals {
        goalType
        title
        milestones
        timeConstraintType
        timeConstraintTime
        projectId
        isGlowGoal
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteUserProfile = /* GraphQL */ `
  mutation DeleteUserProfile(
    $input: DeleteUserProfileInput!
    $condition: ModelUserProfileConditionInput
  ) {
    deleteUserProfile(input: $input, condition: $condition) {
      id
      name
      pillars {
        title
        glowPercent
      }
      projects {
        title
        backgroundColor
        shortName
      }
      morningRoutineSteps
      eveningRoutineSteps
      tasks {
        description
        goalTag
        urgency
        category
        glowTask
        timeConstraintType
        timeConstraintTime
        associatedMilestone
        status
      }
      dates {
        date
        meals
        pxp
        gxp
      }
      goals {
        goalType
        title
        milestones
        timeConstraintType
        timeConstraintTime
        projectId
        isGlowGoal
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
